import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Interpolate from 'react-interpolate-component';

import conditionsRu from "../assets/files/ru/usloviya-obrabotki-pol'zovatel'skih-dannyh-na-sajtah-AO-Bank-131.pdf";
import conditionsEn from '../assets/files/en/terms-of-user-data-processing-on-the-websites-of-Bank-131-JSC.pdf';

import '../styles/components/cookie.scss';

const Cookie = ({ locale }) => {
    const listLanguage = useMemo(() => {
        return {
            termsOfUserData: {
                ru: 'На сайте осуществляется обработка пользовательских данных с\u00A0использованием Cookie в\u00A0соответствии с\u00A0%(termsOfUserData)s. Если вы хотите, чтобы ваши пользовательские данные не обрабатывались, пожалуйста, ограничьте их использование в\u00A0своём браузере.',
                en: 'This website uses cookies to process user data in accordance with the %(termsOfUserData)s. To prevent processing of your data, manage cookie settings in your browser.'
            },
            termsOfUserDataLinkText: {
                ru: 'Условиями обработки пользовательских данных на\u00A0сайтах АО\u00A0«Банк\u00A0131»',
                en: 'Terms of user data processing on the websites of Bank 131 JSC'
            },
            termsOfUserDataLink: {
                ru: conditionsRu,
                en: conditionsEn
            },
            textButton: {
                ru: 'Хорошо',
                en: 'Okay'
            }
        }
    }, []);

    const [permission, setPermission] = useState(true);

    useEffect(() => {
        const perm = localStorage.getItem('bank131CookiePermission');
        if (!perm) {
            setPermission(false);
        }
    }, []);

    const onClickAccess = useCallback(() => {
        localStorage.setItem('bank131CookiePermission', new Date().toISOString());
        setPermission(true);
    }, []);

    return (
        <React.Fragment>
            {!permission && (
                <div className={`Cookie ${window.location.pathname === '/pricing' ? "CookieTop" : ""}`}>
                    <div className="Cookie-Inner">
                        <span className="Cookie-Icon" role="img" aria-label="Cookie">🍪</span>

                        <Interpolate
                            className="Cookie-Text"
                            with={{
                                termsOfUserData: (
                                    <a
                                        href={listLanguage.termsOfUserDataLink[locale]}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {listLanguage.termsOfUserDataLinkText[locale]}
                                    </a>
                                ),
                            }}
                        >
                            {listLanguage.termsOfUserData[locale]}
                        </Interpolate>

                        <button className="Cookie-Button" type="button" onClick={onClickAccess}>
                            {listLanguage.textButton[locale]}
                        </button>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
};

export default Cookie;
